var moduleMap = {
	"./Team.vue": () => {
		return __webpack_require__.e(233).then(() => (() => ((__webpack_require__(31233)))));
	},
	"./Season.vue": () => {
		return __webpack_require__.e(345).then(() => (() => ((__webpack_require__(16345)))));
	},
	"./Round.vue": () => {
		return __webpack_require__.e(657).then(() => (() => ((__webpack_require__(10657)))));
	},
	"./Ladder.vue": () => {
		return __webpack_require__.e(496).then(() => (() => ((__webpack_require__(56496)))));
	},
	"./Competition.vue": () => {
		return __webpack_require__.e(333).then(() => (() => ((__webpack_require__(333)))));
	},
	"./Game.vue": () => {
		return __webpack_require__.e(90).then(() => (() => ((__webpack_require__(8090)))));
	},
	"./Tipping.vue": () => {
		return __webpack_require__.e(92).then(() => (() => ((__webpack_require__(20092)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});